import { Typography } from "@mui/material";
import { PromotionTypeEnum } from "../enums/promotionType";
import { useTranslation } from "react-i18next";

interface Props {
    promotionType: PromotionTypeEnum;
    fontSize?: string | number;
}

const PromotionText = ({ promotionType, fontSize = "13px" }: Props) => {
    const { t } = useTranslation('global');

    const getPromotionText = (type: PromotionTypeEnum): string => {
        switch (type) {
            case PromotionTypeEnum.buy_x_get_x:
                return t('order_page.buy_x_get_x');
            case PromotionTypeEnum.buy_x_get_ds:
                return t('order_page.buy_x_get_ds');
            case PromotionTypeEnum.buy_x_get_y:
                return t('order_page.buy_x_get_y');
            case PromotionTypeEnum.buy_x_u_get_spp:
                return t('order_page.buy_x_u_get_spp');
            case PromotionTypeEnum.buy_x_set_u_get_cbd:
                return t('order_page.buy_x_set_u_get_cbd');
            case PromotionTypeEnum.buy_x_set_a_get_cbp:
                return t('order_page.buy_x_set_a_get_cbp');
            case PromotionTypeEnum.buy_x_set_a_get_rd:
                return t('order_page.buy_x_set_a_get_rd');
            case PromotionTypeEnum.buy_x_set_a_get_cst_by_price:
                return t('order_page.buy_x_set_a_get_cst_by_price');
            case PromotionTypeEnum.buy_x_set_u_get_cst_by_unit:
                return t('order_page.buy_x_set_u_get_cst_by_unit');
            default:
                return '';
        }
    };

    return (
        <Typography
            color="error"
            fontSize={fontSize}
        >
            {getPromotionText(promotionType)}
        </Typography>
    );
};

export default PromotionText;